import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Upload } from "lucide-react";

const MAX = 100 * 1024 * 1024;

async function uploadOne(folderId, f) {
  if (f.size > MAX) { toast.error(`${f.name}: max 100MB`); return false; }
  const fd = new FormData(); fd.append("file", f);
  try { await api.post(`/media/folders/${folderId}/upload`, fd); return true; }
  catch (e) { toast.error(`${f.name}: ${e.response?.data?.detail || "errore upload"}`); return false; }
}

export default function FolderUploader({ folderId, user, onUploaded }) {
  const nav = useNavigate();
  const [pending, setPending] = useState(0);
  const input = useRef(null);
  const onFiles = async (files) => {
    const list = Array.from(files);
    setPending(list.length);
    let ok = 0;
    for (const f of list) {
      if (await uploadOne(folderId, f)) { ok++; }
      setPending(n => n - 1);
    }
    if (ok) { toast.success(`${ok} file caricati`); }
    if (input.current) { input.current.value = ""; }
    onUploaded();
  };
  const label = pending > 0 ? `CARICO... (${pending})` : user ? "CARICA FOTO/VIDEO" : "ACCEDI PER CARICARE";
  return (
    <div>
      <input ref={input} type="file" accept="image/*,video/*" multiple className="hidden" onChange={e=>onFiles(e.target.files)} data-testid="media-file-input"/>
      <button onClick={()=> user ? input.current.click() : nav("/login")} disabled={pending>0}
        className="btn-primary flex items-center gap-2" data-testid="media-upload-btn">
        <Upload className="w-4 h-4"/>{label}
      </button>
    </div>
  );
}
